<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('department.label')" :columns="6">
        <select v-model="filters.department" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="department in departments" :value="department" :key="department">{{ department }}</option>
        </select>
      </form-group>

      <form-group :label="$t('subDepartment.label')" :columns="6" v-if="filters.department">
        <select v-model="filters.subDepartment" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="subDepartment in subDepartments" :value="subDepartment" :key="subDepartment">{{ subDepartment }}</option>
        </select>
      </form-group>

      <product-status :module="module" @change="onChange"/>

    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'
  import ProductStatus from '@/components/tool/batch/shared/filters/marketplace/ProductStatus'
  import { merge } from 'lodash'

  export default {
    data: () => ({
      brands: [],
      departments: [],
      subDepartments: [],
      loading: false,
      filters: {
        brand: null,
        department: null,
        subDepartment: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.zoom.getDepartments()
        .then(departments => { this.departments = departments })
        .catch(() => { this.departments = [] })
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      }
    },
    watch: {
      'filters.department' (department) {
        this.loading = true
        this.filters.subDepartment = null
        api.zoom.getSubDepartments(department)
          .then(subDepartments => { this.subDepartments = subDepartments })
          .catch(() => { this.subDepartments = [] })
          .finally(() => { this.loading = false })
      }
    },
    components: {
      FormGroup,
      Loader,
      ProductStatus
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Zoom.vue?2ec7b219